export const AppConfig = {
  Namespace: "sked",
  McpServerUrl: isStagingOrDev()
    ? "https://mcp-staging.skedsocial.com/mcp"
    : "https://app-mcp.skedsocial.com/mcp",
  ZIndex: {
    Dropdown: 100,
    Notification: 10,
    Drawer: 2000,
  },
};

export function isStagingOrDev(): boolean {
  return (
    process.env.NODE_ENV === "test" ||
    process.env.NODE_ENV === "staging" ||
    process.env.NODE_ENV === "dev"
  );
}
